module.exports = __webpack_public_path__ + "static/media/iPhone13_demand.8e29de6c.png";